import { Camera, Sparkles, PawPrint } from "lucide-react";

const KINDS = [
  { id: "person_photo", label: "Photo", Icon: Camera, hint: "A real photo of a person" },
  { id: "character_image", label: "Character", Icon: Sparkles, hint: "Fan art, a screenshot or a toy" },
  { id: "pet_or_animal_photo", label: "Pet", Icon: PawPrint, hint: "An animal" },
];

const LOOKS_LIKE = { person_photo: "Photo", character_image: "Character", pet_or_animal_photo: "Pet" };

// Item 3/7 — "This is a: Photo · Character · Pet". Shows what the AI detected so the customer knows what they are
// correcting; switching only changes the prompt wording for the NEXT render (no paid call on its own).
export const SubjectKindChips = ({ subject, busy, onChange }) => {
  if (!subject) return null;
  const detected = LOOKS_LIKE[subject.input_kind_detected];
  const corrected = subject.input_kind_detected && subject.input_kind !== subject.input_kind_detected;

  return (
    <div data-testid="subject-kind-chips">
      <div className="flex flex-wrap items-baseline gap-x-3 gap-y-1 mb-3">
        <p className="text-xs font-mono2 uppercase tracking-widest text-muted-foreground">This is a</p>
        {detected && (
          <p data-testid="subject-kind-detected" className="text-xs text-muted-foreground">
            Looks like: <span className="font-semibold text-foreground">{detected}</span>
            {corrected ? " · you corrected it" : ""}
          </p>
        )}
      </div>
      <div className="flex flex-wrap gap-2">
        {KINDS.map(({ id, label, Icon, hint }) => {
          const active = subject.input_kind === id;
          return (
            <button
              key={id}
              type="button"
              title={hint}
              aria-pressed={active}
              disabled={!!busy}
              data-testid={`subject-kind-${id}`}
              onClick={() => !active && onChange(id)}
              className={`inline-flex items-center gap-2 rounded-full px-4 py-2 text-sm font-semibold border transition-colors disabled:opacity-50 ${
                active ? "bg-primary text-primary-foreground border-primary" : "bg-background border-border hover:border-primary"
              }`}
            >
              <Icon className="h-4 w-4 shrink-0" /> {label}
            </button>
          );
        })}
      </div>
      <p className="mt-2 text-xs text-muted-foreground">
        Wrong guess? Pick the right one — the next render describes your duck that way.
      </p>
    </div>
  );
};
